<template>
  <div class="container-fluid mt-4">
    <b-row class="border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Personel Düzenle</span>
      </b-col>

      <b-col cols="auto" class="text-right mb-3">
        <b-btn class="m-1" type="button" variant="danger" to="/Staff" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 390">Personeller</span>
        </b-btn>

        <b-btn class="m-1" type="button" variant="info" @click="Refresh()" :size="ButtonSize">
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth >= 360">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert class="mt-3" show variant="info">Düzenlenen personel: {{ PersonOldName }}</b-alert>

    <form @submit.prevent="SavePerson">
      <table class="m-3 hidden-sm-down display-ib align-top">
        <tr>
          <td>{{ Enums.Role }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-select v-model="Person.RoleID" :options="RolesGUI"></b-form-select>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <td>{{ Enums.Name }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input type="text" v-model="Person.Name" @keypress.enter.prevent="SavePerson"></b-form-input>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <td>{{ Enums.Phone }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input type="text" v-model="Person.Phone" @keypress.enter.prevent="SavePerson"></b-form-input>
            </b-form-group>
          </td>
        </tr>
      </table>

      <table class="m-3 hidden-sm-down display-ib align-top">
        <tr>
          <td>{{ Enums.Username }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input
                type="text"
                disabled
                v-model="Person.Username"
                @keypress.enter.prevent="SavePerson"
              ></b-form-input>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <td>{{ Enums.Password }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-input
                type="password"
                v-model="Person.Password"
                @keypress.enter.prevent="SavePerson"
              ></b-form-input>
            </b-form-group>
          </td>
        </tr>
        <tr>
          <td>{{ Enums.Status }} :</td>
          <td>
            <b-form-group class="formgroup">
              <b-form-checkbox-group
                v-model="Person.Status"
                :options="[{value: 1, text: (Person.Status) ? 'Aktif' : 'Pasif'}]"
                switches
                :state="!!Person.Status"
              ></b-form-checkbox-group>
            </b-form-group>
          </td>
        </tr>
      </table>

      <b-form-group class="formgroup hidden-md-up" :label="Enums.Role">
        <b-form-select v-model="Person.RoleID" :options="RolesGUI"></b-form-select>
      </b-form-group>

      <b-form-group
        class="formgroup hidden-md-up"
        :label="Enums[index]"
        v-for="(property, index) in PersonGUI"
        :key="index"
      >
        <b-form-input type="text" v-model="Person[index]" @keypress.enter.prevent="SavePerson"></b-form-input>
      </b-form-group>

      <b-form-group class="formgroup hidden-md-up" :label="Enums.Username">
        <b-form-input
          type="text"
          v-model="Person.Username"
          disabled
          @keypress.enter.prevent="SavePerson"
        ></b-form-input>
      </b-form-group>

      <b-form-group class="formgroup hidden-md-up" :label="Enums.Password">
        <b-form-input
          type="password"
          v-model="Person.Password"
          @keypress.enter.prevent="SavePerson"
        ></b-form-input>
      </b-form-group>

      <b-form-group class="formgroup hidden-md-up" :label="Enums.Status">
        <b-form-checkbox-group
          v-model="Person.Status"
          :options="[{value: 1, text: (Person.Status !== false) ? 'Aktif' : 'Pasif'}]"
          size="lg"
          switches
          :state="(Person.Status !== false)"
        ></b-form-checkbox-group>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Kaydet</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        Role: "Rolü",
        Username: "Kullanıcı Adı",
        Password: "Yeni Şifre",
        Name: "Adı Soyadı",
        Phone: "Cep Telefonu",
        Status: "Durumu"
      },
      PersonOldName: "",
      Person: {}
    };
  },
  computed: {
    ...mapGetters(["GetStoreData"]),
    ...mapState(["ScreenWidth", "ButtonSize"]),
    ParamID() {
      return this.$route.params.ID;
    },
    PersonGUI() {
      return Object.filterKey(
        this.Person,
        x =>
          [
            "ID",
            "Username",
            "Password",
            "RoleID",
            "RoleName",
            "RegTime",
            "Status"
          ].indexOf(x) === -1
      );
    },
    RolesGUI() {
      let _Roles = [];

      for (let i in this.GetStoreData.Roles) {
        const _Role = this.GetStoreData.Roles[i];

        _Roles.push({
          value: _Role.ID,
          text: _Role.Name
        });
      }

      return _Roles;
    }
  },
  methods: {
    async Refresh() {
      let _Person = Object.assign({}, this.GetStoreData.Staff[this.ParamID]);

      delete _Person.RegTime;
      delete _Person.RoleName;

      await this.$set(this, "PersonOldName", _Person.Name);
      await this.$set(this, "Person", _Person);
    },
    async SavePerson() {
      await this.$store.dispatch("ClearToastMessages");
      await this.$store.dispatch("RemoveAlerts");

      if (String(this.Person.Password).length < 4) {
        await this.$store.dispatch("AddToastMessage", {
          Body: "Şifre 4 haneden kısa olamaz!"
        });

        return false;
      }

      await this.$store.dispatch("AddLoading", "SavePerson");

      await Services.Nozich.Send(
        "SavePerson",
        {
          Person: this.Person
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SavePerson");

          if (Data.Status === "Success") {
            await this.$router.push("/Staff");
          } else if (Data.Message) {
            await this.$store.dispatch("GiveError", Data.Message);
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });

    await this.Refresh();
  }
};
</script>
